var _a;
/* eslint-disable @typescript-eslint/ban-ts-comment */
import { brandingHelpers } from '@simwood/nv-react-components-v2';
import platform from 'platform';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Login from '../components/Login';
import NoWebRTC from '../components/NoWebRTC';
import { isElectron, isWeb } from '../helpers/platform';
import { fetchBranding } from '../reducers/branding';
import { testAuthAndFetchUser } from '../reducers/user';
import styles from '../styles/appHelper.scss';
import App from './App';
const PC = window.RTCPeerConnection ||
    window.mozRTCPeerConnection ||
    window.webkitRTCPeerConnection;
const getUserMedia = navigator.getUserMedia ||
    navigator.webkitGetUserMedia ||
    navigator.msGetUserMedia ||
    navigator.mozGetUserMedia;
let browserSupportsWebRTC = !!PC && !!getUserMedia;
if (platform.name === 'Chrome') {
    const versionArr = (_a = platform.version) === null || _a === void 0 ? void 0 : _a.match(/([^.]+)/g);
    if (versionArr && Number(versionArr[0]) <= 48) {
        browserSupportsWebRTC = false;
    }
}
const RootGuard = () => {
    const dispatch = useDispatch();
    const darkMode = useSelector((state) => state.client.darkMode);
    const authenticated = useSelector((state) => state.user.isAuthenticated);
    const accessToken = useSelector((state) => state.user.accessToken);
    const isAuthTested = useSelector((state) => state.user.isAuthTested);
    const isBrandingInitialized = useSelector((state) => state.branding.isInitialized);
    useEffect(() => {
        if (isWeb()) {
            dispatch(fetchBranding());
        }
        else {
            brandingHelpers.resetBranding(false);
        }
    }, []);
    useEffect(() => {
        if (isBrandingInitialized || isElectron()) {
            dispatch(testAuthAndFetchUser());
        }
    }, [isBrandingInitialized, accessToken, dispatch]);
    let content;
    console.log({ authenticated, isAuthTested });
    if (!browserSupportsWebRTC) {
        content = React.createElement(NoWebRTC, null);
    }
    else if (authenticated) {
        content = React.createElement(App, null);
    }
    else {
        content = React.createElement(Login, null);
    }
    if (!isAuthTested) {
        // TODO_V2 handle branding errors
        // TODO spinner or something?
        return null;
    }
    return (React.createElement("div", { className: darkMode ? styles.dark_theme : styles.base_theme }, content));
};
export default RootGuard;
